import { AgentComponent } from '@agent/agent.component';
import { type Routes } from '@angular/router';
import { PageNotFoundComponent } from '@system/pages/page-not-found/page-not-found.component';
import { GlobalErrorComponent } from '@system/pages/global-error/global-error.component';
import { InternalServerErrorComponent } from '@system/pages/internal-server-error/internal-server-error.component';
import { OfflineComponent } from '@system/pages/offline/offline.component';
import { UserRegistrationRedirectComponent } from '@system/pages/user-registration/user-registration-redirect.component';
import { UserRegistrationComponent } from '@system/pages/user-registration/user-registration.component';
import { AuthAdminGuard } from '@infra/auth/guards/auth-admin.guard';
import { CallbackComponent } from '@system/pages/callback/callback.component';
import { LoginComponent } from '@system/pages/login/login.component';
import { CompanyResolver } from '@infra/resolvers/company.resolver';
import { AuthCompanyUserGuard } from '@infra/auth/guards/auth-company-user.guard';

export const appRoutes: Routes = [
  {
    path: '',
    component: LoginComponent,
  },
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: 'callback',
    component: CallbackComponent,
  },
  {
    path: 'admin',
    loadChildren: async () => (await import('@admin/admin.routes')).adminRoutes,
    canActivate: [AuthAdminGuard],
  },
  {
    path: 'company/:companyurl',
    component: AgentComponent,
    loadChildren: async () => (await import('@agent/agent.routes')).agentRoutes,
    resolve: { ready: CompanyResolver },
    canActivate: [AuthCompanyUserGuard],
  },
  {
    path: 'error',
    component: GlobalErrorComponent,
  },
  {
    path: 'servererror',
    component: InternalServerErrorComponent,
  },
  {
    path: 'offline',
    component: OfflineComponent,
  },
  {
    path: 'welcome',
    component: UserRegistrationComponent,
  },
  {
    // Why do we have 2 user registration paths?
    // This comes from the simple fact we want to log out existing users when they go to the user registration page.
    // Auth0 restricts to which page the application can redirect and there is no wildcard option available for the path part of the URL.
    // But they do allow for redirects to a specific path with dynamic query parameters.
    // Since the old way already had the invitationId in the route, we are now redirecting that to the welcome page that
    // expects invitationId in the query string parameter.
    path: 'welcome/:invitationId',
    component: UserRegistrationRedirectComponent,
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];
